/// <reference path="../../global/fn.js" />

(function ($) {
  $.widget("nsp.header", {
    options: {
      offset: 100,
      cls: "onScreen",
    },
    _create: function () {
      var plgn = this;

      plgn._iniVars();

      plgn._iniMenuNav();

      plgn.onScrollmenu();

      plgn.setWhiteBg();

      plgn.closeMenu();

      plgn.closeMobMenu();

      plgn._logoSlideDown();

      plgn.clearSearchInput();

      plgn.langHover();

      plgn.submitWithEnter();

      $(document).on("window-resized", () => {
        plgn.closeMenu();
        plgn.closeMobMenu();
      });
    },

    _iniVars: function () {
      var plgn = this;
      plgn.wrap = plgn.element;

      //hover timers
      plgn.openTimer = 0;
      plgn.clearTimer = 0;
      plgn.openNewTimer = 0;

      //Wrappers
      plgn.body = $("body");

      plgn.megamenuWraper = plgn.wrap.find(".header__megamenuWrap");
      plgn.megamenuWraperCont = $(
        ".header__megamenuWrap__cont",
        plgn.megamenuWraper
      );
      plgn.megaMenus = $(".header__megamenu", plgn.megamenuWraper);

      //Links
      plgn.menuLinks = plgn.wrap.find(".header__menu__item a");
      plgn.menuDropdownLinks = plgn.menuLinks.filter(".dropdownLink");
      plgn.menuItems = plgn.wrap.find(".header__menu__item");

      plgn.burger = $(".header__burger", plgn.wrap);

      plgn.is = api.vars.is;
    },

    closeMenu: function () {
      var plgn = this;

      plgn.menuDropdownLinks
        .off("click.headerMenuOpen")
        .on("click.headerMenuOpen", function (e) {
          var link = $(this);
          var item = link.closest(".header__menu__item");
          var megamenu = link.data("megamenutarget");

          if (!megamenu) {
            return;
          }

          e.preventDefault();

          clearTimeout(plgn.openTimer);
          clearTimeout(plgn.clearTimer);
          clearTimeout(plgn.openNewTimer);

          if (item.hasClass("active")) {
            plgn._clearMegamenus();
            return;
          }

          plgn._clearMegamenus(function () {
            plgn._showMegaMenu(megamenu, true);
          });
        });
    },

    clearSearchInput: function () {
      var plgn = this;

      plgn.wrap.find(".b-search input").keyup(function () {
        if ($(this).val() !== "") {
          plgn.wrap.find(".b-search__clear").attr("disabled", false);
        }
      });

      plgn.wrap.find(".b-search__clear").click(function (e) {
        e.preventDefault();

        if ($(".b-search input") != "" || $(".b-search input") != null) {
          $(".b-search input").val("");
        }
      });
    },

    closeMobMenu: function () {
      var plgn = this;

      plgn.menuItems
        .off("click.headerMobileClose")
        .on("click.headerMobileClose", function () {
          if (api.vars.windW >= api.vars.scr.desktop) {
            return;
          }

          var item = $(this);

          if (item.find(".dropdownLink").length) {
            return;
          }

          if ($("body").hasClass("mob-menu-open")) {
            $("body").removeClass("mob-menu-open");
            $(".header-mob__bar").removeClass("wht-bg");
          }
        });
    },

    _iniMenuNav: function () {
      var plgn = this;
      plgn.menuItems.hover(
        function () {
          var item = $(this);

          clearTimeout(plgn.openTimer);
          clearTimeout(plgn.clearTimer);
          clearTimeout(plgn.openNewTimer);

          if (
            $(window).height() <= 750 &&
            api.vars.windW > api.vars.scr.desktop
          ) {
            $(".header__megamenuWrap", plgn.wrap).addClass("scrollable");
          }

          if (item.find(".dropdownLink").length) {
            if (!item.hasClass("active")) {
              var megamenusOpen = plgn.menuItems.filter(".active").length;
              var delay = megamenusOpen ? 170 : 250;
              var megamenu = item.find(".dropdownLink").data("megamenutarget");

              plgn.openTimer = setTimeout(function () {
                plgn._clearMegamenus(function () {
                  plgn._showMegaMenu(megamenu, megamenusOpen);
                });
              }, delay);
            }
          } else {
            clearTimeout(plgn.openTimer);
            clearTimeout(plgn.openNewTimer);

            plgn.clearTimer = setTimeout(function () {
              plgn._clearMegamenus();
            }, 300);
          }
        },
        function () {
          clearTimeout(plgn.openTimer);
          clearTimeout(plgn.openNewTimer);

          plgn.clearTimer = setTimeout(function () {
            plgn._clearMegamenus();
          }, 300);
        }
      );

      plgn.megamenuWraper.hover(
        function () {
          clearTimeout(plgn.clearTimer);
        },
        function () {
          plgn.clearTimer = setTimeout(function () {
            plgn._clearMegamenus();
          }, 150);
        }
      );

      plgn.wrap.on("click", function (e) {
        //e.stopPropagation();
      });

      plgn.megamenuWraper.on("click", function (e) {
        e.stopPropagation();
      });
    },

    _clearMegamenus: function (callback) {
      var plgn = this;

      plgn.menuItems.removeClass("active");
      plgn.megaMenus.removeClass("active").hide();
      plgn.body.removeClass("menu-opened");

      if (callback) {
        if (typeof callback === "function") {
          callback();
        }
      }
    },

    _showMegaMenu: function (id, instant) {
      var plgn = this;
      var megamenu = plgn.megaMenus.filter("#" + id);

      if (megamenu.length) {
        //it has mega menu
        plgn.menuDropdownLinks
          .filter('[data-megamenutarget="' + id + '"]')
          .parent()
          .addClass("active");
        megamenu.addClass("active");
        plgn.body.addClass("menu-opened");

        megamenu.css("height", "100%");
        //megamenu.prev().trigger('click');

        if (instant) {
          megamenu.slideDown(300);
        } else {
          setTimeout(function () {
            megamenu.slideDown(300);
          }, 100);
        }
      }
    },

    _logoSlideDown: function () {
      var plgn = this;

      plgn.wrap.find(".header__logo").slideDown(300);
    },

    _openItem: function (item) {
      var plgn = this;

      item.addClass("active");

      item.next(".header__megamenu").slideDown(250, function () {
        api.fn.scrollToScrollableObj(plgn.megamenuWraper, item);
      });
    },

    onScrollmenu: function () {
      var plgn = this;

      jQuery(window).scroll(function () {
        if (!$("body").hasClass("p-search-results")) {
          if (jQuery(window).scrollTop() >= 200) {
            plgn.wrap.addClass("bg-white");
          } else {
            plgn.wrap.removeClass("bg-white");
          }
        }
      });
    },

    setWhiteBg: function () {
      var plgn = this;
      var headerOff = plgn.wrap.offset().top;

      if ($("body").hasClass("p-search-results")) {
        plgn.wrap.addClass("bg-white");
      }

      if (headerOff !== 0) {
        plgn.wrap.addClass("bg-white");
      }
    },

    langHover: function () {
      var plgn = this;

      $(".header__langPanel").mouseenter(function () {
        $(".header__right").addClass("hover");
      });
      $(".header__langPanel").mouseleave(function () {
        $(".header__right").removeClass("hover");
      });
    },

    submitWithEnter() {
      jQuery(".b-search input").keypress(function (e) {
        if (e.which == 13) {
          jQuery(".b-search form").submit();
          return false;
        }
      });
    },
  });
})(jQuery);
